import React from "react";
import Form from 'react-bootstrap/Form'

export class DayForm extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  }

  componentWillMount() {
    if (this.props.daysArr) {
      this.dayCheckboxWrapper()
    }
  }

  handleChange(evt) {
    this.setState({ [evt.target.id]: evt.target.checked }, () => {
      var arr = this.convertToArray()
      this.props.updateDays(arr)
    });
  }

  convertToArray() {
    let arr = [];
    if(this.state.monday) { arr.push("Mon") }
    if(this.state.tuesday) { arr.push("Tue") }
    if(this.state.wednesday) { arr.push("Wed") }
    if(this.state.thursday) { arr.push("Thu") }
    if(this.state.friday) { arr.push("Fri") }
    if(this.state.saturday) { arr.push("Sat") }
    if(this.state.sunday) { arr.push("Sun") }
    return arr;
  }

  dayCheckboxWrapper() {
    let arr = this.props.daysArr
    if(arr.includes("Mon")) {this.setState({ monday: true }) }
    if(arr.includes("Tue")) {this.setState({ tuesday: true }) }
    if(arr.includes("Wed")) {this.setState({ wednesday: true }) }
    if(arr.includes("Thu")) {this.setState({ thursday: true }) }
    if(arr.includes("Fri")) {this.setState({ friday: true }) }
    if(arr.includes("Sat")) {this.setState({ saturday: true }) }
    if(arr.includes("Sun")) {this.setState({ sunday: true }) }
  }

  render() {
    return (
      <div>
        <Form.Check 
          custom
          type={'checkbox'}
          name={'monday'}
          id={'monday'}
          label={'Monday'}
          checked={this.state.monday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'tuesday'}
          id={'tuesday'}
          label={'Tuesday'}
          checked={this.state.tuesday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'wednesday'}
          id={'wednesday'}
          label={'Wednesday'}
          checked={this.state.wednesday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'thursday'}
          id={'thursday'}
          label={'Thursday'}
          checked={this.state.thursday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'friday'}
          id={'friday'}
          label={'Friday'}
          checked={this.state.friday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'saturday'}
          id={'saturday'}
          label={'Saturday'}
          checked={this.state.saturday}
          onChange={(e) => {this.handleChange(e)}}
        />
        <Form.Check 
          custom
          type={'checkbox'}
          name={'sunday'}
          id={'sunday'}
          label={'Sunday'}
          checked={this.state.sunday}
          onChange={(e) => {this.handleChange(e)}}
        />
      </div>
    );
  }
}